import React from 'react';

interface SVGProps {
  title?: string;
  titleId?: string;
  className: string;
}

const IconJobStreetSVG = ({
  title,
  titleId,
  ...props
}: SVGProps): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="20"
    height="15"
    viewBox="0 0 20 15"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <defs>
      <path id="path-1" d="M0 0L5.00025 0 5.00025 4 0 4z" />
      <path id="path-3" d="M0 -0.00025L5.00025 -0.00025 5.00025 4 0 4z" />
    </defs>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(-88 -370)">
        <g transform="translate(60 341)">
          <g transform="translate(28 29)">
            <path fill="#333" d="M19 3H8a1 1 0 010-2h11a1 1 0 010 2" />
            <path fill="#333" d="M19 9H8a1 1 0 010-2h11a1 1 0 010 2" />
            <path fill="#333" d="M19 15H8a1 1 0 010-2h11a1 1 0 010 2" />
            <path fill="#333" d="M4 15H1a1 1 0 010-2h3a1 1 0 010 2" />
            <g>
              <mask id="mask-2" fill="#fff">
                <use xlinkHref="#path-1" />
              </mask>
              <path
                fill="#333"
                d="M2 4a.997.997 0 01-.707-.293l-1-1a.999.999 0 111.414-1.414L2 1.586 3.293.293a.999.999 0 111.414 1.414l-2 2A.997.997 0 012 4"
                mask="url(#mask-2)"
              />
            </g>
            <g transform="translate(0 6)">
              <mask id="mask-4" fill="#fff">
                <use xlinkHref="#path-3" />
              </mask>
              <path
                fill="#333"
                d="M2 4a.997.997 0 01-.707-.293l-1-1a.999.999 0 111.414-1.414L2 1.586 3.293.293a.999.999 0 111.414 1.414l-2 2A.997.997 0 012 4"
                mask="url(#mask-4)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default IconJobStreetSVG;
